import React, { useEffect } from 'react';
import { Select, Option } from '../../../../../../components/Form/Select/Select';
import { t } from '../../../../../../locales/translate';
import { VenueSection, loadVenuePlan } from '../../../../../../model/venue';
import { useRemoteData } from '../../../../../../model/data';
import { Event } from '../../../../../../model/event';
import { useErrorHandler } from '../../../../../../util/util';
import { AddEventItem } from '../../../../../../model/item';
import { sortBy } from 'lodash';

function getSortedSections(sections: VenueSection[]): Option[] {
  const sectionsAsOptions = sections.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  return sortBy(sectionsAsOptions, 'label');
}

interface Props {
  modelEvent: Event;
  onLoad: (newModel: Partial<AddEventItem>) => void;
}

export function EventVariants({ modelEvent, onLoad }: Props): JSX.Element {
  const [event, loading, error] = useRemoteData(
    async () => await loadVenuePlan(modelEvent),
    (db) => {
      return db.table('events').find(modelEvent.id);
    }
  );
  useErrorHandler(error);
  const sections = event?.venuePlan?.sections ?? [];

  useEffect(() => {
    if (!loading && event) {
      const eventSections = event?.venuePlan?.sections;
      onLoad({
        event: {
          ...(modelEvent as Event),
          // Save venue plan to model
          venuePlan: event.venuePlan,
        },
        // preselect section if there's only one
        ...(eventSections?.length === 1
          ? {
              sectionId: eventSections[0]?.id,
              selectedSection: eventSections[0],
            }
          : {}),
      });
    }
  }, [modelEvent.id, loading]);

  return (
    <Select
      name="sectionId"
      loading={loading}
      label={t.model.venueLayout.section}
      options={getSortedSections(sections)}
      allowEmpty
    />
  );
}
